import Menus from "components/features/store/create-menu";

export default Menus;